import { render, staticRenderFns } from "./prescriptionResult.vue?vue&type=template&id=0c3fe1d8&scoped=true"
import script from "./prescriptionResult.vue?vue&type=script&lang=js"
export * from "./prescriptionResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3fe1d8",
  null
  
)

export default component.exports